import React from 'react';
import SvgIcon from './SvgIcon';

const ConferenceMenu = props => {
    return (
        <SvgIcon viewBox="0 0 28 26" {...props}>
            <path
                d="M18.75 5.625a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM16.5 15.375v4.875a1.125 1.125 0 001.125 1.125h2.25A1.125 1.125 0 0021 20.25v-4.875h1.125a1.125 1.125 0 001.125-1.125V9a1.125 1.125 0 00-1.125-1.125h-6.75A1.125 1.125 0 0014.25 9v.375M5.25 5.625a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM9.75 9a1.125 1.125 0 00-1.125-1.125h-6.75A1.125 1.125 0 00.75 9v5.25a1.125 1.125 0 001.125 1.125H3v4.875a1.125 1.125 0 001.125 1.125h2.25A1.125 1.125 0 007.5 20.25v-4.875M12 7.125a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.375 9.375h-6.75A1.125 1.125 0 007.5 10.5v5.25a1.125 1.125 0 001.125 1.125H9.75v4.875a1.125 1.125 0 001.125 1.125h2.25a1.125 1.125 0 001.125-1.125v-4.875h1.125A1.125 1.125 0 0016.5 15.75V10.5a1.125 1.125 0 00-1.125-1.125z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M28 22v4h-4l4-4z" fill="currentColor" />
        </SvgIcon>
    );
};

ConferenceMenu.displayName = 'ConferenceMenuIcon';

export default ConferenceMenu;
